import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export type ChangeRequestField = 'Email' | 'Phone' | 'NIC';
export type ChangeRequestStatus = 'Pending' | 'Approved' | 'Rejected' | 'Cancelled';

export interface MemberChangeRequestDto {
  id: string;
  requestId: string;
  tenantId: string;
  memberId: string;
  memberName?: string | null;
  requestedBy: string;
  fieldName: ChangeRequestField;
  oldValue?: string | null;
  newValue: string;
  status: ChangeRequestStatus;
  reason?: string | null;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  reviewerNotes?: string | null;
  createdDate: string;
  updatedDate?: string | null;
}

export interface CreateChangeRequestBody {
  fieldName: ChangeRequestField;
  newValue: string;
  reason?: string | null;
}

export interface AdminQueueQuery {
  status?: ChangeRequestStatus;
  memberId?: string;
  page?: number;
  pageSize?: number;
}

export interface PagedChangeRequests {
  data: MemberChangeRequestDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class MemberChangeRequestService {
  private api = inject(ApiService);

  createMyRequest(body: CreateChangeRequestBody): Observable<any> {
    return this.api.post<MemberChangeRequestDto>('members/me/change-requests', body);
  }

  getMyRequests(status?: ChangeRequestStatus): Observable<any> {
    return this.api.get<MemberChangeRequestDto[]>('members/me/change-requests',
      status ? { status } : undefined);
  }

  cancelMyRequest(requestId: string): Observable<any> {
    return this.api.delete(`members/me/change-requests/${requestId}`);
  }

  listAdminQueue(params: AdminQueueQuery): Observable<any> {
    return this.api.get<PagedChangeRequests>('admin/member-change-requests', params);
  }

  approve(requestId: string, reviewerNotes?: string): Observable<any> {
    return this.api.post<MemberChangeRequestDto>(
      `admin/member-change-requests/${requestId}/approve`,
      { reviewerNotes: reviewerNotes ?? null }
    );
  }

  reject(requestId: string, reviewerNotes: string): Observable<any> {
    return this.api.post<MemberChangeRequestDto>(
      `admin/member-change-requests/${requestId}/reject`,
      { reviewerNotes }
    );
  }
}
